import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from './../../controls/datatable/datatable.component';
import { Component, OnInit } from '@angular/core';
import { PatchExt } from 'src/app/model/Product';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { Tab, TabColor } from '../../controls/tabs/tabs.component';

enum PatchSelectionTab { SUPERSEDED, DEPENDENT }

@Component({
    selector: 'app-patch-selection',
    templateUrl: './patch-selection.component.html',
    styleUrls: ['./patch-selection.component.css'],
    standalone: false
})
export class PatchSelectionComponent implements OnInit {

  PatchSelectionTab = PatchSelectionTab;
  TabColor = TabColor;
  activeTab: PatchSelectionTab = PatchSelectionTab.SUPERSEDED;
  supersededTab = new Tab('patch-selection-superseded-tab', $localize`Superseded`, 0, false);
  dependentTab = new Tab('patch-selection-dependent-tab', $localize`Dependent`, 0, false);
  tabs: Tab[] = [this.supersededTab, this.dependentTab];
  
  dependentPatches:PatchExt[] = [];
  supersededByPatches:PatchExt[] = [];
  height:string = '350px';
  minheight:string = '300px';
  patch:PatchExt;
  dependentTableCols:DataTableColumn[] = Array<DataTableColumn>(
                                                                new DataTableColumn("name", "Name", ColumnType.STRING, false, "25", ColumnSort.DESC),
                                                                new DataTableColumn("description", "Description", ColumnType.STRING, false, "75")
                                                              );
  dependentTableRows:DataTableRow[] = [];
  supersededPatch:PatchExt;

  constructor(private modalConfig: ModalConfig, private modalRef: ModalRef,) {
    this.patch = this.modalConfig.data.patch;
    this.dependentPatches = this.modalConfig.data.dependentPatches ? this.modalConfig.data.dependentPatches : [];
    this.supersededByPatches = this.modalConfig.data.supersededByPatches;

    if(this.dependentPatches.length > 0 && this.supersededByPatches.length == 0){
      this.activeTab = PatchSelectionTab.DEPENDENT;
    }

    if(this.dependentPatches.length > 0){
      this.dependentPatches.forEach((patch:PatchExt) => {
        let row:DataTableRow = new DataTableRow({name: patch.name, description:patch.description}, [], false, true);
        row.disableCheckbox = true;
        this.dependentTableRows.push(row);
      });
    }

    if(this.supersededByPatches.length > 0){
      this.supersededPatch = this.supersededByPatches[0];
    }

    this.supersededTab.count = this.supersededByPatches.length;
    this.supersededTab.show = this.supersededTab.count > 0;

    this.dependentTab.count = this.dependentPatches.length;
    this.dependentTab.show = this.dependentTab.count > 0;
  }

  getSupersededOption(patch:PatchExt):string {
    let option:string = patch.name + ' : ' + patch.description;
    const limit:number = 95;

    return option.length > limit ? option.substring(0, limit) + '...' : option;
  }

  ngOnInit(): void {

  }

  confirm(): void {
    this.modalRef.close({isConfirmed: true, supersededPatch: this.supersededPatch});
  }

  cancel(): void {
    this.modalRef.close({isConfirmed: false});
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }
}
